module.exports = __webpack_public_path__ + "img/gym.png";